// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container__26O5y","outter":"Checkbox_outter__WJuNA","pointer":"Checkbox_pointer__8rzju"};